import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { hydrateRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'mobx-react'
import 'common/src/vtj/server/create-nonce'
import * as AppState from 'todistukset-ui/src/vtj/app-state'
import App from 'todistukset-ui/src/vtj/components/app/App.react'
import i18next from 'todistukset-ui/src/vtj/i18next'

const initialState = window.INITIAL_STATE
const store = AppState.init({ initialState })
i18next.changeLanguage(store.common.lang)

hydrateRoot(
  document.getElementById('app'),
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
)
